import request from '@/axios';




export const upload = (row) => {
	return request({
		url: '/oss/upload/put-file',
		method: 'post',
		data: row
	})
}

export const uploadBase64 = (data) => {

	let file = base64ToFile(data);
	const formData = new FormData();
	formData.append('file', file);
	return request({
		url: '/oss/upload/put-file',
		method: 'post',
		data: formData
	})
}


function base64ToFile(data, callback) {
	let base = window.atob(data.substring(data.indexOf(',') + 1))
	let length = base.length
	let url = new Uint8Array(length)
	while (length--) {
		url[length] = base.charCodeAt(length)
	}
	let file = new File([url], `${new Date().getTime()}.jpg`, {
		type: 'image/jpeg'
	})
	return file;
}